import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import FormType from '../Form/FormType';
import Utils from '../../utils';
import InputValidator from '../Form/InputValidator';
import ValidatorError from '../Form/ValidatorError';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import { CARD_VALUES, SCALAR_TYPE, TARGET_PROPERTY } from '../../constants';
import { getText, TEXT_KEY } from '../../utils/localization';
var SCALAR_TYPES = [SCALAR_TYPE.NUMBER, SCALAR_TYPE.BOOLEAN, SCALAR_TYPE.STRING];
var AutoFormInput = /*#__PURE__*/function (_Component) {
  function AutoFormInput() {
    var _this;
    _classCallCheck(this, AutoFormInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AutoFormInput, [].concat(args));
    _this.state = {
      status: '',
      value: '',
      checked: false,
      cardNickname: '',
      autoCompleteStates: {
        autoCompleteResults: [],
        autoCompleteValue: '',
        autoCompletePayload: {},
        manualAddressThresholdReached: false
      },
      focused: !!_this.props.focused
    };
    _this._inputCompleteHandler = function () {
      var value = _this.props.type === FormType.AUTOCOMPLETE ? _this.state.autoCompleteStates.autoCompletePayload : _this.state.value;
      var isToggle = _this.props.type === FormType.CHECKBOX || _this.props.type === FormType.TOGGLE;
      _this.props.emitInput({
        key: _this.props.id,
        value: isToggle ? _this.state.checked : value,
        validated: isToggle ? _this.state.checked : _this.validateField()
      });
    };
    _this._formChangeHandler = function (value) {
      if (value !== null && value.hasOwnProperty(TARGET_PROPERTY)) {
        value = value.target.value;
      }
      _this.setState({
        value: value
      });
    };
    _this._formFocusHandler = function () {
      _this.setState({
        focused: true
      });
    };
    _this._formBlurHandler = function () {
      _this.setState({
        focused: false
      });
    };
    _this._formToggleHandler = function () {
      _this.setState(function (prevState) {
        return {
          checked: !prevState.checked
        };
      });
    };
    _this._formAutocompleteHandler = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value, item) {
        var newAutoCompleteStates;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (value !== null && value.hasOwnProperty(TARGET_PROPERTY)) {
                value = value.target.value;
              }
              _this.setState({
                value: value
              });
              newAutoCompleteStates = _this.state.autoCompleteStates;
              newAutoCompleteStates.autoCompletePayload = {};
              if (value.length > 2 && !_this.state.autoCompleteStates.manualAddressThresholdReached) {
                newAutoCompleteStates.manualAddressThresholdReached = true;
              }
              if (!(item && item.format)) {
                _context.next = 11;
                break;
              }
              _context.next = 8;
              return _this.assignExperianPayload(item.format, newAutoCompleteStates);
            case 8:
              newAutoCompleteStates = _context.sent;
              _context.next = 18;
              break;
            case 11:
              if (!(item && item.suggestion)) {
                _context.next = 15;
                break;
              }
              return _context.abrupt("return", _this._toggleAutocompleteMode());
            case 15:
              _context.next = 17;
              return _this.handleAutoComplete(value, newAutoCompleteStates);
            case 17:
              newAutoCompleteStates = _context.sent;
            case 18:
              _this.setState({
                autoCompleteStates: newAutoCompleteStates
              }, _this._inputCompleteHandler());
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    _this.handleAutoComplete = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(value, newAutoCompleteStates) {
        var sanitizedValue, promise, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(value.length >= 5)) {
                _context2.next = 12;
                break;
              }
              sanitizedValue = encodeURIComponent(value);
              _context2.next = 4;
              return fetch("https://api.edq.com/capture/address/v2/search?auth-token=".concat(ENVIRONMENT_VARIABLES.EXPERIAN_ENVIRONMENT_KEY, "&query=").concat(sanitizedValue, "&country=AUS"));
            case 4:
              promise = _context2.sent;
              if (!promise.ok) {
                _context2.next = 10;
                break;
              }
              _context2.next = 8;
              return promise.json();
            case 8:
              response = _context2.sent;
              if (response.results.length > 0) {
                newAutoCompleteStates.autoCompleteResults = response.results;
              } else {
                newAutoCompleteStates.autoCompleteResults = [{
                  suggestion: getText(TEXT_KEY.NO_MATCHES)
                }];
              }
            case 10:
              _context2.next = 13;
              break;
            case 12:
              if (_this.state.autoCompleteStates.autoCompleteResults.length > 0) {
                newAutoCompleteStates.autoCompleteResults = [];
              }
            case 13:
              return _context2.abrupt("return", newAutoCompleteStates);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
    _this.assignExperianPayload = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(formatUrl, newAutoCompleteStates) {
        var autoCompletePayload, promise;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              autoCompletePayload = {};
              _context3.next = 3;
              return fetch("".concat(formatUrl, "&auth-token=").concat(ENVIRONMENT_VARIABLES.EXPERIAN_ENVIRONMENT_KEY));
            case 3:
              promise = _context3.sent;
              if (!promise.ok) {
                _context3.next = 9;
                break;
              }
              _context3.next = 7;
              return promise.json();
            case 7:
              autoCompletePayload = _context3.sent;
              if (Object.keys(autoCompletePayload).length > 0) {
                autoCompletePayload.components.push({
                  manual: false
                });
              }
            case 9:
              newAutoCompleteStates.autoCompleteResults = [];
              newAutoCompleteStates.autoCompletePayload = autoCompletePayload;
              return _context3.abrupt("return", newAutoCompleteStates);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x5, _x6) {
        return _ref3.apply(this, arguments);
      };
    }();
    _this._toggleAutocompleteMode = function () {
      var newAutoCompleteStates = _this.state.autoCompleteStates;
      newAutoCompleteStates.autoCompletePayload = {};
      _this.setState({
        value: '',
        autoCompleteStates: newAutoCompleteStates
      });
      _this.props.emitLayoutChange('toggleAutocomplete');
    };
    _this.validateField = function () {
      if (_this.props.validator) {
        var valid = _this.checkValidation(_this.props.validator, _this.state.value);
        if (!valid && !Utils.isEmpty(_this.state.value)) {
          var validatorKey = Object.keys(InputValidator).find(function (key) {
            return InputValidator[key] === _this.props.validator;
          });
          _this.setState({
            status: ValidatorError()[validatorKey]
          });
        } else {
          _this.setState({
            status: ''
          });
        }
        return valid;
      }
      return false;
    };
    _this.checkValidation = function (validator, value) {
      return validator(value);
    };
    _this.getFormChangeHandler = function () {
      switch (_this.props.type) {
        case FormType.CHECKBOX:
        case FormType.TOGGLE:
          return _this._formToggleHandler;
        case FormType.AUTOCOMPLETE:
          return _this._formAutocompleteHandler;
        default:
          return _this._formChangeHandler;
      }
    };
    return _this;
  }
  _inherits(AutoFormInput, _Component);
  return _createClass(AutoFormInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._inputCompleteHandler();
      if (this.props.initialValue) {
        this.setState({
          value: this.props.initialValue
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var defaultValues = [CARD_VALUES.VISA, CARD_VALUES.MASTERCARD, CARD_VALUES.AMEX];
      if (prevState.checked !== this.state.checked || prevState.value !== this.state.value || prevState.autoCompleteStates.autoCompletePayload !== this.state.autoCompleteStates.autoCompletePayload) {
        this._inputCompleteHandler();
      }
      if (prevProps.value !== this.props.value && this.props.value !== this.state.value && SCALAR_TYPES.includes(typeof this.props.value)) {
        this.setState({
          value: this.props.value
        });
      }
      if (prevProps.initialValue && prevProps.initialValue != this.state.value && this.state.cardNickname != this.state.value) {
        if (defaultValues.indexOf(this.state.value) < 0) {
          this.setState({
            value: this.state.value
          });
          this.setState({
            cardNickname: this.state.value
          });
        } else {
          this.setState({
            value: prevProps.initialValue
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isToggle = this.props.type === FormType.CHECKBOX || this.props.type === FormType.TOGGLE;
      return this.props.render(_objectSpread(_objectSpread({}, this.props), {}, {
        showCheckmark: this.props.validator && this.props.validator !== InputValidator.NOT_EMPTY,
        status: this.state.status,
        value: isToggle ? this.state.checked : this.state.value,
        formChangeHandler: this.getFormChangeHandler(),
        autoCompleteStates: this.state.autoCompleteStates,
        toggleAutocompleteMode: this._toggleAutocompleteMode,
        focused: !Utils.isEmpty(this.state.value) || this.props.focused ? true : this.state.focused,
        formFocusHandle: this._formFocusHandler,
        formBlurHandle: this._formBlurHandler
      }));
    }
  }]);
}(Component);
AutoFormInput.defaultProps = {
  disabled: false
};
export { AutoFormInput as default };